﻿<template>
    <q-tab-panel name="EventRaceTab">
        <q-tabs v-model="selClass" align="left" dense no-caps narrow-indicator active-color="secondary"
                v-if="moreClasses">
            <q-tab :ripple="false" name="-all" :label="ts( 'allClasses' )" />
            <q-tab :ripple="false" :name="boatClass.boatClass.id"
                   v-for="boatClass in attendedClasses"
                   :key="boatClass.id">
                <div class="row items-center no-wrap">
                    <span class="q-tab__label">{{ boatClass.eventClassName }}</span>
                    <q-icon
                        v-if="boatClass.isElimination" name="flag" color="negative"
                        size="18px" class="q-ml-xs"
                        :title="ts( 'raceMode-elimination' )" />
                </div>
            </q-tab>
        </q-tabs>

        <template v-if="isEliminationClass">
            <q-tabs
                :model-value="isEliminationResult ? 'result' : selRound" align="left" dense no-caps narrow-indicator
                active-color="secondary" class="q-mt-md"
                @update:model-value="selectRoundBar">
                <q-tab
                    v-for="round in eliminationRoundsCount" :key="round" :ripple="false"
                    :name="round" :label="ts( 'roundNo', { no: round } )" />
                <q-tab :ripple="false" name="result" :label="ts( 'eliminationResult' )" />
            </q-tabs>

            <div v-if="!eliminationKeyValid" class="q-pa-md">
                {{ ts( 'eliminationKeyInvalid' ) }}
            </div>

            <template v-else>
            <template v-if="!isEliminationResult">
                <q-tabs
                    :model-value="isHeatsDivision ? '-heats-division' : selHeat" align="left" dense no-caps narrow-indicator
                    active-color="secondary" class="q-mt-sm"
                    @update:model-value="selectHeatTab">
                    <q-tab
                        v-for="heat in eliminationHeatsCount" :key="heat" :ripple="false"
                        :name="heat" :label="selectedEventClass?.eliminationHeatName( selRound, heat )" />
                    <q-tab :ripple="false" name="-heats-division" :label="ts( 'heatsDivision' )" />
                </q-tabs>

                <q-tabs
                    v-if="!isHeatsDivision"
                    :model-value="isStartList ? 'start' : 'finish'" align="left" dense no-caps narrow-indicator
                    active-color="secondary" class="q-mt-sm"
                    @update:model-value="selectHeatView">
                    <q-tab :ripple="false" name="start" :label="ts( 'eliminationStartList' )" />
                    <q-tab :ripple="false" name="finish" :label="ts( 'eliminationFinishes' )" />
                </q-tabs>

                <div v-if="isHeatsDivision" class="q-mt-md">
                    <template v-if="heatDetermined">
                        <q-markup-table flat class="elimination-start-list">
                            <thead>
                            <tr>
                                <th class="text-right">{{ ts( 'orderShortcut' ) }}</th>
                                <th class="text-left">{{ ts( 'group' ) }}</th>
                                <th class="text-left">{{ ts( 'sailNo' ) }}</th>
                                <th class="text-left">{{ ts( 'crew' ) }}</th>
                                <th class="text-left">{{ event.descInResultsTitle ?? ts( 'note' ) }}</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="row in heatsDivisionRows" :key="row.boat.id">
                                <td class="text-right">{{ row.order }}.</td>
                                <td class="text-left">{{ row.group }}</td>
                                <td class="text-left">
                                    <span :class="'fi fi-' + row.boat.sailNoFlag" />
                                    {{ row.boat.sailNo }}
                                </td>
                                <td class="text-left minicrewlist">
                                    <div
                                        v-for="crew in row.boat.orderedCrewList" :key="crew.id"
                                        :class="crew.captain ? 'captain' : ''">
                                        <q-icon
                                            :name="crew.sex === 'male' ? 'man' : 'woman'"
                                            :color="crew.sex === 'male' ? 'blue' : 'red'"
                                            size="1.5em" />
                                        {{ crew.reverseFullName }}
                                    </div>
                                </td>
                                <td class="text-left">{{ row.boat.detail }}</td>
                            </tr>
                            </tbody>
                        </q-markup-table>
                        <div v-if="heatsDivisionRows.length === 0" class="q-pa-md">
                            {{ ts( 'noBoatsInHeat' ) }}
                        </div>
                        <div v-else class="q-mt-lg">
                            <q-btn
                                outline color="secondary" :label="ts( 'printHeatsDivision' )"
                                @click="printHeatsDivision" />
                        </div>
                    </template>
                    <div v-else class="q-pa-md">
                        {{ ts( selRound === 1 ? 'eliminationStartUndefinedRace' : 'eliminationStartUndefinedRound' ) }}
                    </div>
                </div>

                <div v-else-if="isStartList" class="q-mt-md">
                    <template v-if="heatDetermined">
                        <q-markup-table flat class="elimination-start-list">
                            <thead>
                            <tr>
                                <th class="text-right">{{ ts( 'orderShortcut' ) }}</th>
                                <th class="text-left">{{ ts( 'sailNo' ) }}</th>
                                <th class="text-left">{{ ts( 'crew' ) }}</th>
                                <th class="text-left">{{ event.descInResultsTitle ?? ts( 'note' ) }}</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="( boat, index ) in eliminationHeatBoats" :key="boat.id">
                                <td class="text-right">{{ Number( index ) + 1 }}.</td>
                                <td class="text-left">
                                    <span :class="'fi fi-' + boat.sailNoFlag" />
                                    {{ boat.sailNo }}
                                </td>
                                <td class="text-left minicrewlist">
                                    <div
                                        v-for="crew in boat.orderedCrewList" :key="crew.id"
                                        :class="crew.captain ? 'captain' : ''">
                                        <q-icon
                                            :name="crew.sex === 'male' ? 'man' : 'woman'"
                                            :color="crew.sex === 'male' ? 'blue' : 'red'"
                                            size="1.5em" />
                                        {{ crew.reverseFullName }}
                                    </div>
                                </td>
                                <td class="text-left">{{ boat.detail }}</td>
                            </tr>
                            </tbody>
                        </q-markup-table>
                        <div v-if="eliminationHeatBoats.length === 0" class="q-pa-md">
                            {{ ts( 'noBoatsInHeat' ) }}
                        </div>
                    </template>
                    <div v-else class="q-pa-md">
                        {{ ts( selRound === 1 ? 'eliminationStartUndefinedRace' : 'eliminationStartUndefinedRound' ) }}
                    </div>
                </div>

                <div v-else class="q-mt-md">
                    <template v-if="heatDetermined">
                        <div class="row justify-between items-start q-gutter-sm">
                            <div class="col-sm-auto text-center">
                                <div v-if="heatEnterModel === ResultsEnterModel.EnterNumByNum">
                                    <div v-if="heatUnfinishedBoats.length > 0">
                                        <q-select
                                            ref="finishedHeatSailNoField"
                                            v-model="finishedHeatSailNo" :label="ts( 'sailNo' )" autofocus
                                            :options="heatUnfinishedBoatsList"
                                            option-value="value" option-label="label" class="qe q-mt-sm" autocomplete="true"
                                            use-input emit-value map-options input-debounce="0" hide-selected fill-input
                                            @filter="heatBoatFilter"
                                            @keyup.enter.stop.prevent="chooseHeatBoat( null )"
                                            @keyup.tab.stop.prevent="chooseHeatBoat( null )" />
                                        <div class="text-right">
                                            <q-btn
                                                class="q-mt-md" outline color="primary" :label="ts( 'addResult' )"
                                                @click="chooseHeatBoat( null, true )" />
                                            <q-btn-dropdown
                                                class="q-ml-md q-mt-md" outline color="primary"
                                                :label="ts( 'addOtherResult' )">
                                                <q-list>
                                                    <q-item
                                                        clickable v-close-popup v-for="result in otherResultsList"
                                                        :key="result.value"
                                                        @click.prevent="chooseHeatBoat( result.value, true )">
                                                        <q-item-section avatar>{{ result.value }}</q-item-section>
                                                        <q-item-section class="long-desc">{{ result.label }}</q-item-section>
                                                    </q-item>
                                                </q-list>
                                            </q-btn-dropdown>
                                        </div>

                                        <div v-if="race !== null">
                                            <div class="q-mt-lg" />
                                            <q-btn-dropdown class="q-mt-xl" outline color="secondary" :label="ts( 'enterMissing' )">
                                                <q-list>
                                                    <q-item
                                                        clickable v-close-popup v-for="result in missedResultsList"
                                                        :key="result.value"
                                                        @click="addMissingHeat( result.value )">
                                                        <q-item-section avatar>{{ result.value }}</q-item-section>
                                                        <q-item-section class="long-desc">{{ result.label }}</q-item-section>
                                                    </q-item>
                                                </q-list>
                                            </q-btn-dropdown>
                                        </div>
                                    </div>
                                    <q-card flat bordered class="q-mt-md" v-else>
                                        <q-card-section class="row q-gutter-md items-center justify-between">
                                            <q-icon class="col-md-auto" name="check" size="30px" color="positive" />
                                            <div class="col">{{ ts( 'heatAllResultsEntered' ) }}</div>
                                        </q-card-section>
                                    </q-card>
                                </div>
                                <div class="q-mt-lg" v-else>
                                    <div class="q-mb-lg">
                                        <q-toggle v-model="showCaptainName" :label="ts( 'showCaptainName' )" />
                                    </div>
                                    <div class="row q-gutter-md justify-center">
                                        <q-btn
                                            outline :class="'col-3a boat-btn' + ( heatFinishedIds.includes( boat.id ) ? ' finished' : '' )"
                                            :color="heatFinishedIds.includes( boat.id ) ? 'secondary' : 'primary'" no-caps
                                            :disable="heatFinishedIds.includes( boat.id )"
                                            @click="finishHeatBoat( boat )"
                                            v-for="boat in eliminationHeatBoats" :key="boat.id">
                                            <div class="sail-no">{{ boat.sailNo }}</div>
                                            <div class="boat-name" v-if="boat.name !== undefined && boat.name !== null && boat.name.length > 0">
                                                {{ boat.name }}
                                            </div>
                                            <div class="boat-captain" v-if="showCaptainName && boat.captain !== null">
                                                {{ boat.captain.reverseShortName }}
                                            </div>
                                        </q-btn>
                                    </div>
                                </div>

                                <q-btn-dropdown
                                    outline color="secondary" class="q-mt-xl"
                                    :label="ts( heatEnterModel === ResultsEnterModel.EnterNumByNum ? 'resultsEnterNumByNum' : 'resultsEnterDirectClick' )">
                                    <q-list>
                                        <q-item clickable v-close-popup @click="heatEnterModel = ResultsEnterModel.EnterNumByNum">
                                            <q-item-section>{{ ts( 'resultsEnterNumByNum' ) }}</q-item-section>
                                        </q-item>
                                        <q-item clickable v-close-popup @click="heatEnterModel = ResultsEnterModel.EnterDirectClick">
                                            <q-item-section>{{ ts( 'resultsEnterDirectClick' ) }}</q-item-section>
                                        </q-item>
                                    </q-list>
                                </q-btn-dropdown>
                            </div>

                            <div class="col-sm-auto text-right">
                                <div class="q-pa-md" v-if="heatResults.length > 0">
                                    <div class="text-right q-mb-sm">
                                        <q-input v-model="heatSearchBoat" dense :label="ts( 'searchBoat' )">
                                            <template v-slot:append>
                                                <q-avatar>
                                                    <q-icon name="search" size="2em" />
                                                </q-avatar>
                                            </template>
                                        </q-input>
                                    </div>
                                    <q-table
                                        flat :rows="heatFilteredResults" :columns="heatResultsColumns" row-key="id"
                                        class="results-table" hide-pagination
                                        v-model:pagination="heatPagination" :rows-per-page-options="[0]">
                                        <template v-slot:body="props">
                                            <q-tr
                                                :props="props"
                                                :class="{ 'last-entered-result': props.row.boat?.id === lastEnteredHeatBoatId }">
                                                <q-td v-for="col in props.cols" :key="col.name" :props="props">
                                                    <span v-if="col.name === 'actions'">
                                                        <q-btn
                                                            flat icon="delete" color="negative" class="qe-ignore-focus"
                                                            :title="ts( 'removeResult' )"
                                                            @click="removeHeatResultUi( props.row )" />
                                                    </span>
                                                    <span v-else-if="col.name === 'index'">{{ props.row.rooster }}.</span>
                                                    <span v-else-if="col.name === 'order'" class="cursor-pointer">
                                                        <q-icon
                                                            name="more_horiz" color="secondary" class="cursor-pointer"
                                                            v-if="props.row.order === null" />
                                                        <span v-else>{{ col.value }}</span>
                                                        <q-popup-edit
                                                            v-model="props.row.order" :title="ts( 'editOrder' )" auto-save
                                                            v-slot="scope" buttons
                                                            @save="( val, origVal ) => updateHeatOrder( props.row, val, origVal )">
                                                            <q-input type="number" v-model.number="scope.value" dense autofocus />
                                                        </q-popup-edit>
                                                    </span>
                                                    <span
                                                        v-else-if="col.name === 'other'" class="cursor-pointer"
                                                        :title="props.row.attrInfo">
                                                        <q-icon
                                                            name="more_horiz" color="secondary" class="cursor-pointer"
                                                            v-if="props.row.other === null" />
                                                        {{ col.value }}
                                                        <q-popup-edit
                                                            v-model="props.row.other" :title="ts( 'editResult' )" auto-save
                                                            v-slot="scope" buttons
                                                            @save="( val ) => updateHeatOther( props.row, val )">
                                                            <q-select
                                                                v-model="scope.value" dense autofocus :options="otherResultsList"
                                                                option-value="value" option-label="label" emit-value>
                                                                <template v-slot:option="scope">
                                                                    <q-item v-bind="scope.itemProps">
                                                                        <q-item-section avatar>{{ scope.opt.value }}</q-item-section>
                                                                        <q-item-section class="long-desc">{{ scope.opt.label }}</q-item-section>
                                                                    </q-item>
                                                                </template>
                                                            </q-select>
                                                        </q-popup-edit>
                                                    </span>
                                                    <span
                                                        v-else-if="col.name === 'boat'"
                                                        :title="( props.row.boat?.name ? props.row.boat.name + ' ' : '' ) + ( props.row.boat?.captain ? ts( 'captainShort' ) + ' ' + props.row.boat.captain.fullName : '' )">
                                                        {{ col.value }}
                                                    </span>
                                                    <span v-else>{{ col.value }}</span>
                                                </q-td>
                                            </q-tr>
                                        </template>
                                    </q-table>
                                </div>
                            </div>
                        </div>
                    </template>
                    <div v-else class="q-pa-md">
                        {{ ts( selRound === 1 ? 'eliminationStartUndefinedRace' : 'eliminationStartUndefinedRound' ) }}
                    </div>
                </div>
            </template>
            <div v-else class="q-mt-md">
                <div class="text-right q-mb-md" v-if="eliminationResultsDiverged">
                    <q-btn
                        outline color="primary" :label="ts( 'writeRaceResults' )"
                        @click="writeEliminationResults" />
                </div>
                <q-markup-table v-if="eliminationResults.length > 0" flat class="elimination-start-list">
                    <thead>
                    <tr>
                        <th class="text-right">{{ ts( 'orderShortcut' ) }}</th>
                        <th class="text-left">{{ ts( 'sailNo' ) }}</th>
                        <th class="text-left">{{ ts( 'crew' ) }}</th>
                        <th class="text-left">{{ ts( 'eliminationLastHeat' ) }}</th>
                        <th class="text-right">{{ ts( 'score' ) }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="row in eliminationResults" :key="row.id">
                        <td class="text-right">{{ row.rank }}.</td>
                        <td class="text-left">
                            <span :class="'fi fi-' + row.boat.sailNoFlag" />
                            {{ row.boat.sailNo }}
                        </td>
                        <td class="text-left minicrewlist">
                            <div
                                v-for="crew in row.boat.orderedCrewList" :key="crew.id"
                                :class="crew.captain ? 'captain' : ''">
                                <q-icon
                                    :name="crew.sex === 'male' ? 'man' : 'woman'"
                                    :color="crew.sex === 'male' ? 'blue' : 'red'"
                                    size="1.5em" />
                                {{ crew.reverseFullName }}
                            </div>
                        </td>
                        <td class="text-left">{{ row.heatName }}</td>
                        <td
                            class="text-right cursor-pointer"
                            :title="tcs( 'pointsNo', row.points ) + ( row.attrInfo !== '' ? ' &ndash; ' + row.attrInfo : '' )">
                            {{ nvl( row.other, ns( row.points, 'points' ) ) }}
                        </td>
                    </tr>
                    </tbody>
                </q-markup-table>
                <div v-else class="q-pa-md">
                    {{ ts( 'eliminationResultUnknown' ) }}
                </div>
            </div>
            </template>
        </template>

        <div v-else class="row q-mt-md justify-between items-start q-gutter-sm">
            <div class="col-sm-auto text-center">
                <div v-if="resultsEnterModel === ResultsEnterModel.EnterNumByNum">
                    <div>
                        <div v-if="race === null || race?.unfinishedBoats( selClass ) > 0">
                            <q-select
                                ref="finishedSailNoField"
                                v-model="finishedSailNo" :label="ts( 'sailNo' )" autofocus
                                :options="unfinishedBoatsList"
                                option-value="value" option-label="label" class="qe q-mt-sm" autocomplete="true"
                                use-input emit-value map-options input-debounce="0" hide-selected fill-input
                                @filter="boatFilter"
                                @keyup.enter.stop.prevent="chooseBoat( null )"
                                @keyup.tab.stop.prevent="chooseBoat( null )" />
                            <div class="text-right">
                                <q-btn class="q-mt-md" outline color="primary" :label="ts( 'addResult' )"
                                       @click="chooseBoat( null, true )" />
                                <q-btn-dropdown class="q-ml-md q-mt-md" outline color="primary"
                                                :label="ts( 'addOtherResult' )">
                                    <q-list>
                                        <q-item
                                            clickable v-close-popup v-for="result in otherResultsList"
                                            :key="result.value"
                                            @click.prevent="chooseBoat( result.value, true )">
                                            <q-item-section avatar>
                                                {{ result.value }}
                                            </q-item-section>
                                            <q-item-section class="long-desc">
                                                {{ result.label }}
                                            </q-item-section>
                                        </q-item>
                                    </q-list>
                                </q-btn-dropdown>
                            </div>

                            <div v-if="race !== null">
                                <div class="q-mt-lg" />

                                <q-btn-dropdown class="q-mt-xl" outline color="secondary" :label="ts( 'enterMissing' )">
                                    <q-list>
                                        <q-item
                                            clickable v-close-popup v-for="result in missedResultsList"
                                            :key="result.value"
                                            @click="addMissing( result.value )">
                                            <q-item-section avatar>
                                                {{ result.value }}
                                            </q-item-section>
                                            <q-item-section class="long-desc">
                                                {{ result.label }}
                                            </q-item-section>
                                        </q-item>
                                    </q-list>
                                </q-btn-dropdown>
                            </div>
                        </div>
                        <q-card flat bordered class="q-mt-md" v-else>
                            <q-card-section class="row q-gutter-md items-center justify-between">
                                <q-icon class="col-md-auto" name="check" size="30px" color="positive" />
                                <div class="col" v-if="race?.isSkippedBoatClass( selClass )">{{
                                        ts( 'skipRace' )
                                    }}
                                </div>
                                <div class="col" v-else>{{ ts( 'allResultsEntered' ) }}</div>
                            </q-card-section>
                        </q-card>
                    </div>
                    <div class="q-mt-lg"><br></div>
                    <q-markup-table flat class="q-mt-lg unfinished-table">
                        <thead>
                        <tr>
                            <th></th>
                            <th class="text-left">{{ ts( 'boatClass' ) }}</th>
                            <th class="text-right">{{ ts( 'finishedUnfinished' ) }}</th>
                            <th class="text-right">{{ ts( 'total' ) }}</th>
                            <th class="text-left" v-if="isHandicapUsed">{{ ts( 'startTime' ) }}</th>
                            <th></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="boatClass in selectedClasses" :key="boatClass.boatClass.id"
                            :class="( race === null ? event.filteredBoats( boatClass.boatClass.id ).length > 0 : ( !race.isSkippedBoatClass( boatClass.boatClass.id ) && race.unfinishedBoats( boatClass.boatClass.id ) > 0 ) ) ? 'unfinished' : 'finished'">
                            <td class="text-center">
                                <q-icon flat name="close" color="secondary" size="22px"
                                        v-if="race?.isSkippedBoatClass( boatClass.boatClass.id )">
                                    <q-tooltip>{{ ts( 'skipRace' ) }}</q-tooltip>
                                </q-icon>
                                <q-icon flat name="cancel" color="negative" size="22px"
                                        v-else-if="race === null ? event.filteredBoats( boatClass.boatClass.id ).length > 0 : race.unfinishedBoats( boatClass.boatClass.id ) > 0">
                                    <q-tooltip>{{ ts( 'notFinishedRace' ) }}</q-tooltip>
                                </q-icon>
                                <q-icon flat name="check_circle" color="positive" size="22px" v-else>
                                    <q-tooltip>{{ ts( 'allBoatsFinishedRace' ) }}</q-tooltip>
                                </q-icon>
                            </td>
                            <td class="text-left" style="white-space: nowrap">
                                {{ boatClass.eventClassName }}
                                <q-icon
                                    v-if="boatClass.isElimination" name="flag" color="negative"
                                    size="18px" class="q-ml-xs"
                                    :title="ts( 'raceMode-elimination' )" />
                            </td>
                            <td
                                :class="{ 'text-right': true, 'cursor-pointer': ( race === null ? event.filteredBoats( boatClass.boatClass.id ).length : race.unfinishedBoats( boatClass.boatClass.id ) ) > 0 }"
                                :title="( race === null ? event.filteredBoats( boatClass.boatClass.id ).length : race.unfinishedBoats( boatClass.boatClass.id ) ) > 0 ? ts( 'showUnfinishedBoatList' ) : ''"
                                @click="( race === null ? event.filteredBoats( boatClass.boatClass.id ).length : race.unfinishedBoats( boatClass.boatClass.id ) ) > 0 ? showUnfinished( event.unfinishedBoats( race, boatClass.boatClass.id ) ) : {}">
                                {{
                                    String( race === null ? 0 : race?.finishedBoats( boatClass.boatClass.id ) ) + '/' +
                                    String( race === null ? event.filteredBoats( boatClass.boatClass.id ).length : race.unfinishedBoats( boatClass.boatClass.id ) )
                                }}
                            </td>
                            <td class="text-right">
                                {{
                                    race === null ? event.filteredBoats( boatClass.boatClass.id ).length : race.totalBoats( boatClass.boatClass.id )
                                }}
                            </td>
                            <td class="text-left cursor-pointer" v-if="isHandicapUsed" @click="editRaceStartTime( boatClass.boatClassId )">
                                <div v-if="boatClass.handicapSystem !== null">
                                    <q-icon name="more_horiz" color="secondary"
                                            v-if="race === null || ( race.startTime( boatClass.boatClass.id ) === null && useRepo( EventRaceDetailedClass ).where( 'eventRaceId', race?.id ).where( 'boatClassId', boatClass.boatClassId ).first()?.specialBehavior !== SPECIAL_BEHAVIOR_CONTINUOUS_START )" />
                                    <q-icon name="double_arrow" color="secondary"
                                            v-else-if="race !== null && useRepo( EventRaceDetailedClass ).where( 'eventRaceId', race.id ).where( 'boatClassId', boatClass.boatClassId ).first()?.specialBehavior === SPECIAL_BEHAVIOR_CONTINUOUS_START">
                                        <q-tooltip>{{ ts( 'continuousStartTime' ) }}</q-tooltip>
                                    </q-icon>
                                    <span v-else>{{ race.startTime( boatClass.boatClass.id, true ) }}</span>
                                </div>
                            </td>
                            <td class="text-center">
                                <q-btn
                                    flat icon="close" color="secondary" :title="ts( 'skipRace' )"
                                    v-if="race !== null && race.finishedBoats( boatClass.boatClass.id ) === 0 && !race.isSkippedBoatClass( boatClass.boatClass.id )"
                                    @click="skipRace( boatClass.boatClass.id )"
                                />
                                <q-btn
                                    flat icon="chevron_right" color="secondary" :title="ts( 'unskipRace' )"
                                    v-else-if="race !== null && race.finishedBoats( boatClass.boatClass.id ) === 0 && race.isSkippedBoatClass( boatClass.boatClass.id )"
                                    @click="unskipRace( boatClass.boatClass.id )"
                                />
                                <q-btn
                                    flat icon="delete" color="negative" :title="ts( 'removeResultForClass' )"
                                    v-if="race !== null && race.finishedBoats( boatClass.boatClass.id ) > 0 && !boatClass.isElimination"
                                    @click="removeResultsForClass( boatClass.boatClass.id )"
                                />
                            </td>
                        </tr>
                        </tbody>
                    </q-markup-table>
                </div>
                <div class="q-mt-lg" v-else-if="resultsEnterModel === ResultsEnterModel.EnterDirectClick">
                    <div class="q-mb-lg">
                        <q-toggle v-model="showCaptainName" :label="ts( 'showCaptainName' )" />
                    </div>
                    <div class="row q-gutter-md justify-center">
                        <q-btn
                            outline :class="'col-3a boat-btn' + ( boat.finished ? ' finished' : '' )"
                            :color="boat.finished ? 'secondary' : 'primary'" no-caps
                            :disable="boat.finished"
                            @click="finishBoat( boat )"
                            v-for="boat in race === null ? event.allBoatsOrdered( selClass ) : race?.allBoatsOrdered( selClass )"
                            :key="boat.id">
                            <div class="sail-no">{{ boat.sailNo }}</div>
                            <div class="boat-name"
                                 v-if="boat.name !== undefined && boat.name !== null && boat.name.length > 0">
                                {{ boat.name }}
                            </div>
                            <div class="boat-captain"
                                 v-if="showCaptainName && boat.crew?.filter( c => c.captain ).length > 0">
                                {{ boat.crew.filter( c => c.captain )[ 0 ].reverseShortName }}
                            </div>
                            <div class="boat-class" v-if="attendedClasses.length > 1">{{
                                    boat.boatClass?.shortcut
                                }}
                            </div>
                        </q-btn>
                    </div>
                </div>
                <div class="q-mt-lg" v-else>
                    <div class="q-mb-lg">
                        <q-toggle v-model="showCaptainName" :label="ts( 'showCaptainName' )" />
                        <q-toggle v-model="finishIsOpened" :label="ts( 'finishIsOpened' )" />
                    </div>

                    <div class="row q-gutter-md justify-center">
                        <q-btn
                            outline :class="'col-3a boat-btn' + ( boat.finished ? ' finished' : '' )"
                            :color="boat.finished ? 'secondary' : 'primary'" no-caps
                            :disable="boat.finished"
                            @click="countRound( boat )"
                            v-for="boat in race === null ? event.allBoatsOrdered( selClass ) : race?.allBoatsOrdered( selClass )"
                            :key="boat.id">
                            <div class="sail-no">{{ boat.sailNo }}</div>
                            <div class="boat-name"
                                 v-if="boat.name !== undefined && boat.name !== null && boat.name.length > 0">
                                {{ boat.name }}
                            </div>
                            <div class="boat-captain"
                                 v-if="showCaptainName && boat.crew.filter( c => c.captain ).length > 0">
                                {{ boat.crew.filter( c => c.captain )[ 0 ].reverseShortName }}
                            </div>
                            <div class="boat-class" v-if="attendedClasses.length > 1">{{
                                    boat.boatClass?.shortcut
                                }}
                            </div>
                        </q-btn>
                    </div>
                </div>

                <q-btn-dropdown
                    outline color="secondary" class="q-mt-xl"
                    :label="ts( resultsEnterModel === ResultsEnterModel.EnterNumByNum ? 'resultsEnterNumByNum' :
								  ( resultsEnterModel === ResultsEnterModel.EnterDirectClick ? 'resultsEnterDirectClick'
								  : 'resultsCountRounds' ) )">
                    <q-list>
                        <q-item clickable v-close-popup @click="setResultsMode( ResultsEnterModel.EnterNumByNum )">
                            <q-item-section>{{ ts( 'resultsEnterNumByNum' ) }}</q-item-section>
                        </q-item>
                        <q-item clickable v-close-popup @click="setResultsMode( ResultsEnterModel.EnterDirectClick )">
                            <q-item-section>{{ ts( 'resultsEnterDirectClick' ) }}</q-item-section>
                        </q-item>
                        <q-item clickable v-close-popup @click="setResultsMode( ResultsEnterModel.EnterCountRounds )">
                            <q-item-section>{{ ts( 'resultsCountRounds' ) }}</q-item-section>
                        </q-item>
                    </q-list>
                </q-btn-dropdown>
            </div>
            <div class="col-sm-auto text-right">
                <div v-if="noResultsInRace" class="text-center">
                    <q-btn :label="ts( 'removeRace' )" color="secondary" outline class="q-mb-xl" @click="removeRace()" />
                </div>
                <div class="q-pa-md" v-if="race !== null">
                    <div v-if="resultsEnterModel === ResultsEnterModel.EnterCountRounds">
                        <q-table
                            ref="raceRoundsField"
                            flat :rows="currentFilteredRounds" :columns="roundsColumns" row-key="index"
                            :class="{ 'results-table': true, 'scrollable-results': true }"
                            :virtual-scroll="raceResultStyle === RaceResultStyle.ScrollableTable"
                            :virtual-scroll-item-size="48"
                            :virtual-scroll-sticky-size-start="48" :virtual-scroll-sticky-size-end="0"
                            v-model:pagination="pagination" :rows-per-page-options="[0]">
                            <template v-slot:body="props">
                                <q-tr
                                    :props="props"
                                    :class="{'last-entered-result': props.row.id === lastEnteredRoundId}">
                                    <q-td v-for="col in props.cols" :key="col.name" :props="props">
                                        <span v-if="col.name === 'actions'">
                                            <q-btn
                                                flat icon="delete" color="negative" class="qe-ignore-focus"
                                                :title="ts( 'removeRound' )"
                                                @click="removeRound( props.row )" />
                                        </span>
                                        <span v-else>
                                            {{ col.value }}
                                        </span>
                                    </q-td>
                                </q-tr>
                            </template>
                        </q-table>
                    </div>
                    <div v-else>
                        <div class="text-right q-mb-sm" v-if="raceResultStyle === RaceResultStyle.ScrollableTable">
                            <q-input v-model="searchBoat" dense :label="ts( 'searchBoat' )">
                                <template v-slot:append>
                                    <q-avatar>
                                        <q-icon name="search" size="2em" />
                                    </q-avatar>
                                </template>
                            </q-input>
                        </div>
                        <q-table
                            ref="raceResultsField"
                            flat :rows="currentFilteredResults" :columns="resultsColumns" row-key="index"
                            :visible-columns="visibleResultsColumns"
                            :class="{ 'results-table': true, 'scrollable-results': raceResultStyle === RaceResultStyle.ScrollableTable }"
                            v-draggable-table="raceResultStyle === RaceResultStyle.ScrollableTable ? '' : { options: { mode: currentFilteredResults.length > 2 ? 'row' : 'none', onlyBody: true, dragHandler: 'tr.draggable', dragula: { accepts: reorderOnAccept } }, onDrop: reorderResults }"
                            :virtual-scroll="raceResultStyle === RaceResultStyle.ScrollableTable"
                            :virtual-scroll-item-size="48"
                            :virtual-scroll-sticky-size-start="48" :virtual-scroll-sticky-size-end="0"
                            v-model:pagination="pagination" :rows-per-page-options="[0]">
                            <template v-slot:body="props">
                                <q-tr
                                    :props="props"
                                    :class="{ 'class-separator': props.rowIndex > 0 && currentFilteredResults[ props.rowIndex - 1 ].boat?.boatClassId !== props.row.boat?.boatClassId, 'draggable': props.row.order !== null, [ 'boatClass-' + props.row.boat?.boatClassId ]: true, 'last-entered-result': props.row.boat?.id === lastEnteredBoatId }">
                                    <q-td v-for="col in props.cols" :key="col.name" :props="props">
                                    <span v-if="col.name === 'actions'">
                                        <q-btn
                                            flat icon="delete" color="negative" class="qe-ignore-focus"
                                            :title="ts( 'removeResult' )"
                                            @click="removeResult( props.row )" />
                                    </span>
                                        <span v-else-if="col.name === 'index'">
                                        {{ props.row.rooster }}.
                                    </span>
                                        <span v-else-if="col.name === 'order'" class="cursor-pointer">
                                        <q-icon name="more_horiz" color="secondary" class="cursor-pointer"
                                                v-if="props.row.order === null" />
                                        <span
                                            :title="( ( props.row.rounds !== null && props.row.rounds !== undefined ) ? tcs( 'roundsNo', props.row.rounds ) + ' &rarr; ' : '' ) + props.row.realTime() + ' s x ' + ( Math.round( ( props.row.boat.calcHandicapCoef( null, race.id ) + Number.EPSILON ) * 10000 ) / 10000 ) + ' = ' + props.row.calculatedTime() + ' s'"
                                            v-else-if="props.row.isHandicap">{{
                                                ds( props.row.finishTime, DateFormat.Time )
                                            }}</span>
                                        <span v-else>{{ col.value }}</span>
                                        <q-popup-edit
                                            :modelValue="props.row.finishTime === null ? null : ds( props.row.finishTime, DateFormat.Time )"
                                            :title="ts( 'editFinishTime' )" auto-save
                                            v-slot="scope" buttons
                                            v-if="props.row.isHandicap || props.row.boat.eventClassHandicapSystem !== null"
                                            @save="( val, origVal ) => updateResultFinishTime( props.row, val, origVal )">
                                            <q-input v-model="scope.value" dense autofocus mask="fulltime"
                                                     :roles="['fulltime']" :label="ts( 'finishTime' )">
                                                <template v-slot:append>
                                                    <q-icon name="access_time" class="cursor-pointer">
                                                        <q-popup-proxy cover transition-show="scale"
                                                                       transition-hide="scale">
                                                            <q-time v-model="scope.value" flat now-btn with-seconds
                                                                    format24h>
                                                                <div class="row items-center justify-end">
                                                                    <q-btn v-close-popup :label="ts( 'close' )"
                                                                           color="primary" flat />
                                                                </div>
                                                            </q-time>
                                                        </q-popup-proxy>
                                                    </q-icon>
                                                </template>
                                            </q-input>
                                        </q-popup-edit>
                                        <q-popup-edit v-model="props.row.order" :title="ts( 'editOrder' )" auto-save
                                                      v-slot="scope" buttons v-else
                                                      @save="( val, origVal ) => updateResultOrder( props.row, val, origVal )">
                                            <q-input type="number" v-model.number="scope.value" dense autofocus />
                                        </q-popup-edit>
                                    </span>
                                        <span v-else-if="col.name === 'other'" class="cursor-pointer"
                                              :title="props.row.attrInfo">
                                        <q-icon name="more_horiz" color="secondary" class="cursor-pointer"
                                                v-if="props.row.other === null" />
                                        {{ col.value }}
                                        <q-popup-edit
                                            v-model="props.row.other" :title="ts( 'editResult' )" auto-save
                                            v-slot="scope" buttons
                                            @save="( val, origVal ) => updateResultOther( props.row, val, origVal )">
                                            <q-select
                                                v-model="scope.value" dense autofocus :options="otherResultsList"
                                                option-value="value" option-label="label"
                                                emit-value @keyp.enter="scope.set">
                                                <template v-slot:option="scope">
                                                    <q-item v-bind="scope.itemProps">
                                                        <q-item-section avatar>
                                                            {{ scope.opt.value }}
                                                        </q-item-section>
                                                        <q-item-section class="long-desc">
                                                            {{ scope.opt.label }}
                                                        </q-item-section>
                                                    </q-item>
                                                </template>
                                            </q-select>
                                        </q-popup-edit>
                                    </span>
                                        <span v-else-if="col.name === 'boat'"
                                              :title="( ( props.row.boat.name !== null && props.row.boat.name !== undefined && props.row.boat.name.length > 0 ) ? props.row.boat.name + ' ' : '' ) + props.row.boat?.crew.filter( c => c.captain ).length > 0 ? ts( 'captainShort' ) + ' ' + props.row.boat?.crew.filter( c => c.captain )[ 0 ].fullName : ''">
                                        {{ col.value }}
                                    </span>
                                        <span v-else>{{ col.value }}</span>
                                    </q-td>
                                </q-tr>
                            </template>
                        </q-table>
                        <q-btn outline color="secondary" :label="ts( 'printFinishSheet' )" @click="printFinishSheet" />
                    </div>
                </div>
            </div>
        </div>
    </q-tab-panel>
</template>

<script setup lang="ts">
import { handicapBaseDate } from '@/orm/catalogs/Handicaps'
import { missedResults, otherResultFormula, otherResults } from '@/orm/catalogs/OtherResults'
import { parseResultFormula } from '@/orm/scoring'
import { localization } from '@/plugins/i18n'
import { DateFormat, ds, ns, tcs, ts } from '@/plugins/i18nFormat'
import { buildPrintMeta, buildStandardHeader } from '@/plugins/printReports'
import { useDecisionNeeded, useFinishedTaskSound, useNegativeSound, usePositiveSound } from '@/plugins/sounds'
import nvl from '@/utils/nvl'
import BoatList from '@dialogs/BoatList.vue'
import Confirmation from '@dialogs/Confirmation.vue'
import StartTime from '@dialogs/StartTime.vue'
import ResultAttr from '@dialogs/ResultAttr.vue'
import ResultHandicap from '@dialogs/ResultHandicap.vue'
import BoatClass from '@model/BoatClass'
import { ResultsEnterModel } from '@model/Event'
import EventBoat from '@model/EventBoat'
import EventBoatRace from '@model/EventBoatRace'
import EventRace from '@model/EventRace'
import EventRaceDetailedClass, { SPECIAL_BEHAVIOR_CONTINUOUS_START } from '@model/EventRaceDetailedClass'
import EventRaceSkippedClass from '@model/EventRaceSkippedClass'
import EventHeatResult from '@model/EventHeatResult'
import EventResult from '@model/EventResult'
import EventRound from "@model/EventRound"
import { Defaults, Options, RaceResultStyle } from '@model/Setting'
import EventsRepo from '@repo/EventsRepo'
import SettingsRepo from '@repo/SettingsRepo'
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'
import { useRepo } from 'pinia-orm'
import { QSelect, useQuasar } from 'quasar'
import { computed, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'

const quasar = useQuasar()
const route = useRoute()
const router = useRouter()

const props = defineProps<{ event: any }>()
const event = computed( () => ( props.event ?? useRepo( EventsRepo ).getEvent( String( route.params.eventId ), true ) ) )

const searchBoat = ref( '' )

pdfMake.addVirtualFileSystem( pdfFonts )

const raceNo = ref( route.params.raceId )

const race = computed( () => raceNo.value === undefined
    ? null
    : event.value?.races.find( r => r.race === parseInt( raceNo.value ) ) ?? null
)

watch(
    () => route.params.raceId, refresh, { immediate: true }
)

const attendedClasses = computed( () => ( event.value?.orderedClasses
    .filter( ( eventClass ) => !race.value?.isSkippedBoatClass( eventClass.boatClassId )
        && !( ( ( race.value?.race ?? 0 ) >= 2 || ( race.value === null && ( event.value?.races.length ?? 0 ) > 0 ) ) && eventClass.isLongDistance ) ) ) )

const moreClasses = computed( () => ( attendedClasses.value.length > 1 ) )
const selClass = ref( event.value?.orderedClasses.length > 1 ? '-all' : event.value?.orderedClasses[ 0 ].boatClassId )

// Selected event class (null for the "all classes" tab).
const selectedEventClass = computed( () => ( selClass.value === '-all'
    ? null
    : attendedClasses.value.find( boatClass => boatClass.boatClass.id === selClass.value ) ) )

// A specific class raced in elimination mode gets a completely different race tab (round bar).
const isEliminationClass = computed( () => ( selectedEventClass.value?.isElimination ?? false ) )
// A malformed heat-size advancement key blocks the race views until it is fixed in the configuration.
const eliminationKeyValid = computed( () => ( selectedEventClass.value?.isEliminationHeatSizesValid ?? true ) )
const eliminationRoundsCount = computed( () => ( selectedEventClass.value?.eliminationRounds ?? 0 ) )

const eliminationHeatsCount = computed( () => ( selectedEventClass.value?.eliminationHeats ?? 0 ) )

const selRound = ref( route.params.round !== undefined ? parseInt( route.params.round ) : 1 )
const selHeat = ref( route.params.heat !== undefined ? parseInt( route.params.heat ) : 1 )
// The elimination result has its own dedicated /results URL; the plain race URL is the first round / first heat.
const isEliminationResult = ref( route.name === 'EventRaceResult' )
// Within a heat we switch between the finishes (base URL) and the start list (/start).
const isStartList = ref( route.name === 'EventRaceHeatStart' )
// The heats division shows every group of the round at once (own /heats-division URL, no per-heat selection).
const isHeatsDivision = ref( route.name === 'EventRaceRoundHeatsDivision' )

function selectRound ( round ) {
    isEliminationResult.value = false
    isHeatsDivision.value = false
    selRound.value = round
    selHeat.value = 1

    if ( raceNo.value !== undefined )
        router.push( { name: 'EventRaceHeat', params: { raceId: raceNo.value, round, heat: 1 } } )
}

function selectHeat ( heat ) {
    selHeat.value = heat

    if ( raceNo.value !== undefined )
        router.push( { name: isStartList.value ? 'EventRaceHeatStart' : 'EventRaceHeat',
            params: { raceId: raceNo.value, round: selRound.value, heat } } )
}

// The heat bar carries both the individual heats and the "-heats-division" entry.
function selectHeatTab ( value ) {
    if ( value === '-heats-division' ) {
        isHeatsDivision.value = true

        if ( raceNo.value !== undefined )
            router.push( { name: 'EventRaceRoundHeatsDivision', params: { raceId: raceNo.value, round: selRound.value } } )

        return
    }

    isHeatsDivision.value = false
    selectHeat( value )
}

function selectRoundBar ( round ) {
    if ( round === 'result' ) {
        isEliminationResult.value = true

        if ( raceNo.value !== undefined )
            router.push( { name: 'EventRaceResult', params: { raceId: raceNo.value } } )
    }
    else {
        selectRound( round )
    }
}

function selectHeatView ( view ) {
    isStartList.value = view === 'start'

    if ( raceNo.value !== undefined )
        router.push( { name: view === 'start' ? 'EventRaceHeatStart' : 'EventRaceHeat',
            params: { raceId: raceNo.value, round: selRound.value, heat: selHeat.value } } )
}

watch(
    () => route.params.round,
    ( round ) => {
        if ( round !== undefined )
            selRound.value = parseInt( round )
    }
)

watch(
    () => route.params.heat,
    ( heat ) => {
        // Leaving a heat URL (e.g. switching round) resets to the first heat.
        selHeat.value = heat !== undefined ? parseInt( heat ) : 1
    }
)

// Keep the sub-menu selection in sync with the URL (direct entry, back/forward button).
watch(
    () => route.name,
    ( name ) => {
        isEliminationResult.value = name === 'EventRaceResult'
        isStartList.value = name === 'EventRaceHeatStart'
        isHeatsDivision.value = name === 'EventRaceRoundHeatsDivision'
    }
)

// Switching classes drops any round/heat/result URL back to the plain race URL
// (which, for an elimination class, is the first round / first heat).
watch( selClass, () => {
    if ( route.name !== 'EventRaceTab' && raceNo.value !== undefined )
        router.push( { name: 'EventRaceTab', params: { raceId: raceNo.value } } )

    if ( isEliminationClass.value ) {
        selRound.value = 1
        selHeat.value = 1
    }
} )

const isFirstRace = computed( () => ( race.value !== null
    ? race.value.race === 1
    : ( event.value?.races.length ?? 0 ) === 0 ) )

// The last already-created race - the one a not-yet-saved new race would follow.
const previousRace = computed( () => ( [ ...( event.value?.races ?? [] ) ].sort( ( a, b ) => b.race - a.race )[ 0 ] ?? null ) )

// Start lists of all heats of the current round. When the race exists we delegate to EventRace.
// For a not-yet-created race we can still show round 1: the first race from the entry list, a later
// race from the previous race's final standings. An empty array means the round is not determined yet.
const eliminationRoundHeats = computed( () => {
    if ( !isEliminationClass.value )
        return []

    if ( race.value !== null )
        return race.value.eliminationRoundHeats( selClass.value, selRound.value )

    if ( selRound.value !== 1 )
        return []

    if ( isFirstRace.value )
        return selectedEventClass.value?.eliminationFirstRoundHeats() ?? []

    return previousRace.value?.nextRaceFirstRoundHeats( selClass.value ) ?? []
} )

// Whether the currently selected round/heat start list is determined (else we show a notice).
const heatDetermined = computed( () => ( eliminationRoundHeats.value.length > 0 ) )

// Boats of the currently selected heat, displayed ordered by sail number (as in the full-event
// start list). Heat membership itself is decided by eliminationRoundHeats and stays untouched.
const eliminationHeatBoats = computed( () => (
    [ ...( eliminationRoundHeats.value[ selHeat.value - 1 ] ?? [] ) ]
        .sort( ( a, b ) => a.sailNoSortable.localeCompare( b.sailNoSortable ) ) ) )

// The round's heats division across all groups: ordered by heat (group) and then by sail number,
// each row tagged with its group name and a per-group running order restarting at 1 in each heat.
const heatsDivisionRows = computed( () => {
    if ( !isEliminationClass.value )
        return []

    const rows = []

    eliminationRoundHeats.value.forEach( ( heatBoats, heatIndex ) => {
        const group = selectedEventClass.value?.eliminationHeatName( selRound.value, heatIndex + 1 )

        ;[ ...heatBoats ]
            .sort( ( a, b ) => a.sailNoSortable.localeCompare( b.sailNoSortable ) )
            .forEach( ( boat, index ) => rows.push( { boat, group, order: index + 1 } ) )
    } )

    return rows
} )

// Final elimination standings (only once the last round is fully finished, else empty).
const eliminationResults = computed( () => ( ( isEliminationClass.value && race.value !== null )
    ? race.value.eliminationResults( selClass.value )
    : [] ) )

// The standings must be committed into EventResult before the normal results/print/scoring reflect them.
const eliminationResultsDiverged = computed( () => ( ( isEliminationClass.value && race.value !== null )
    ? race.value.eliminationResultsDiverged( selClass.value )
    : false ) )

function writeEliminationResults () {
    race.value?.writeEliminationResults( selClass.value )
    event.value?.setModified()
}

// --- Heat finish entry (Dojezdy) ---------------------------------------------------------------
const heatEnterModel = ref( ResultsEnterModel.EnterNumByNum )
const finishedHeatSailNo = ref( null )
const finishedHeatSailNoField = ref()
const lastEnteredHeatBoatId = ref( null )
const heatPagination = ref()

function heatBoatOption ( boat ) {
    return {
        value: boat.id,
        label: boat.sailNo
            + ( boat.name ? ' ' + boat.name : '' )
            + ( boat.captain !== null ? ' — ' + ts( 'captainShort' ) + ' ' + boat.captain.reverseFullName : '' ),
        searchLabel: boat.sailNo + ( boat.captain !== null ? ' ' + boat.captain.reverseFullName : '' ),
        sailNumber: boat.sailNumber
    }
}

const heatFinishedIds = computed( () => ( race.value !== null
    ? race.value.heatFinishedBoatIds( selClass.value, selRound.value, selHeat.value )
    : [] ) )

const heatUnfinishedBoats = computed( () => ( eliminationHeatBoats.value
    .filter( ( boat ) => !heatFinishedIds.value.includes( boat.id ) )
    .map( heatBoatOption ) ) )

const heatUnfinishedBoatsList = ref( heatUnfinishedBoats.value )

const heatResults = computed( () => ( race.value !== null
    ? race.value.orderedHeatResults( selClass.value, selRound.value, selHeat.value )
    : [] ) )

const heatSearchBoat = ref( '' )
const heatFilteredResults = computed( () => ( heatSearchBoat.value.length > 0
    ? heatResults.value.filter( r => r.boat?.sailNo.toLocaleLowerCase().includes( heatSearchBoat.value.toLocaleLowerCase() )
        || r.boat?.captain?.fullName.toLocaleLowerCase().includes( heatSearchBoat.value.toLocaleLowerCase() ) )
    : heatResults.value ) )

const heatAllFinished = computed( () => ( eliminationHeatBoats.value.length > 0 && heatUnfinishedBoats.value.length === 0 ) )

// Keep the sail-number dropdown options in sync with the current heat (the search filter overrides while typing).
watch( heatUnfinishedBoats, ( list ) => { heatUnfinishedBoatsList.value = list }, { immediate: true } )

const allClasses = computed( () => ( selClass.value === '-all' ) )
const selectedClasses = computed( () => ( allClasses.value
    ? attendedClasses.value
    : attendedClasses.value.filter( boatClass => boatClass.boatClass.id === selClass.value ) ) )
const unfinishedBoats = computed( () => ( event.value?.unfinishedBoats( race.value, allClasses.value ? null : selClass.value ) ) )
const currentResults = computed( () => ( race.value?.orderedResults( selClass.value ) ) )
const missedResultsList = computed( () => ( missedResults() ) )
const otherResultsList = computed( () => ( otherResults() ) )
const noResultsInRace = computed( () => !race.value?.anyResults )
const raceResultStyle = computed( () => ( useRepo( SettingsRepo ).getOption( Options.PreferredRaceResultStyle, Defaults.PreferredRaceResultStyle ) ) )

const currentFilteredResults = computed( () => ( searchBoat.value.length > 0
    ? currentResults.value.filter( result => result.boat.sailNo.toLocaleLowerCase().includes( searchBoat.value.toLocaleLowerCase() )
        || result.boat.captain?.fullName.toLocaleLowerCase().includes( searchBoat.value.toLocaleLowerCase() ) )
    : currentResults.value ) )

const useRounds = computed( () => ( currentResults.value !== null && currentResults.value !== undefined
    && currentResults.value.some( result => result.rounds !== null && result.rounds !== undefined ) ) )

const currentRounds = computed( () => ( race.value?.orderedRounds( selClass.value ) ) )
const currentFilteredRounds = computed( () => currentRounds.value )

const unfinishedBoatsList = ref( unfinishedBoats.value )
const finishedSailNoField = ref()
const finishedSailNo = ref( null )
const pagination = ref()
const lastEnteredBoatId = ref( null )
const lastEnteredRoundId = ref( null )
const raceResultsField = ref()
const raceRoundsField = ref()
const showCaptainName = ref( false )
const finishIsOpened = ref( false )

const resultsEnterModel = ref( nvl( event.value.currentResultsEnterMode, ResultsEnterModel.EnterNumByNum ) )

const useBoatNames = computed( () => ( event.value.getClass( selClass.value )?.boatClass.useBoatNames ) )
const isBoatNamesUsed = computed( () => ( event.value.getClass( selClass.value )?.isBoatNamesUsed ?? false ) )

const isHandicapUsed = computed( () => ( selClass.value === '-all'
    ? attendedClasses.value.some( eventClass => eventClass.handicapSystem !== null )
    : ( attendedClasses.value.filter( eventClass => eventClass.boatClassId === selClass.value )[ 0 ] )?.handicapSystem !== null )
)

const negativeSound = useNegativeSound()
const positiveSound = usePositiveSound()
const finishedTaskSound = useFinishedTaskSound()
const decisionNeededSound = useDecisionNeeded()

const roundsColumns = ref( [
    {
        name: 'index',
        label: ts( 'orderShortcut' ),
        align: 'right',
        field: row => row.rooster + '.'
    },
    {
        name: 'boatClass',
        label: ts( 'boatClass' ),
        align: 'left',
        field: row => row.boat?.eventClassName
    },
    {
        name: 'boat',
        label: ts( 'boat' ),
        align: 'left',
        field: row => row.boat?.sailNo
    },
    {
        name: 'round',
        label: ts( 'round' ),
        align: 'right',
        field: row => row.round
    },
    {
        name: 'ts',
        label: ts( 'transit' ),
        align: 'left',
        field: row => ds( row.ts, DateFormat.Time )
    },
    {
        name: 'actions',
        label: ts( 'actions' ),
        align: 'center',
        field: () => ''
    }
] )

const visibleResultsColumns = [ 'index', 'boatClass', 'boat', 'order', 'other', 'points', 'actions', ...( useRounds.value ? [ 'rounds' ] : [] ) ]

const resultsColumns = ref( [
    {
        name: 'index',
        label: ts( 'orderShortcut' ),
        align: 'right',
        field: row => row.rooster
    },
    {
        name: 'boatClass',
        label: ts( 'boatClass' ),
        align: 'left',
        field: row => row.boat?.eventClassName
    },
    {
        name: 'boat',
        label: ts( 'boat' ),
        align: 'left',
        field: row => row.boat?.sailNo
    },
    {
        name: 'rounds',
        label: ts( 'rounds' ),
        align: 'right',
        field: row => row.rounds ?? ''
    },
    {
        name: 'order',
        label: ts( 'order' ),
        align: 'right',
        field: row => row.order
    },
    {
        name: 'other',
        label: ts( 'score' ),
        align: 'right',
        field: row => nvl( row.other, '' )
    },
    {
        name: 'points',
        label: ts( 'points' ),
        align: 'right',
        field: row => ns( row.points, 'points' )
    },
    {
        name: 'actions',
        label: '',
        align: 'center',
        field: () => ''
    }
] )

const heatResultsColumns = ref( [
    {
        name: 'index',
        label: ts( 'orderShortcut' ),
        align: 'right',
        field: row => row.rooster
    },
    {
        name: 'boat',
        label: ts( 'boat' ),
        align: 'left',
        field: row => row.boat?.sailNo
    },
    {
        name: 'order',
        label: ts( 'order' ),
        align: 'right',
        field: row => row.order
    },
    {
        name: 'other',
        label: ts( 'score' ),
        align: 'right',
        field: row => nvl( row.other, '' )
    },
    {
        name: 'points',
        label: ts( 'points' ),
        align: 'right',
        field: row => ns( row.points, 'points' )
    },
    {
        name: 'actions',
        label: '',
        align: 'center',
        field: () => ''
    }
] )

async function refresh ( raceId ) {
    raceNo.value = raceId
}

function reorderOnAccept ( el, target, source, sibling ) {
    const sourceClass = el?.querySelector( '.draggable' )?.className.split( ' ' ).find( ( cl ) => cl.substring( 0, 10 ) === 'boatClass-' )
    const targetClass = sibling?.querySelector( '.draggable' )?.className.split( ' ' ).find( ( cl ) => cl.substring( 0, 10 ) === 'boatClass-' )

    return sibling?.querySelector( '.draggable' ) && sourceClass === targetClass
}

function boatFilter ( val, update ) {
    if ( val === '' ) {
        update( () => {
            unfinishedBoatsList.value = unfinishedBoats.value
        } )
        return
    }

    update(
        () => {
            const needle = val.toSearchable()
            unfinishedBoatsList.value = unfinishedBoats.value.filter( boat => boat.searchLabel.toSearchable().includes( needle ) )
        },
        ( ref: QSelect ) => {
            if ( val !== '' && ref.options.length > 0 ) {
                ref.setOptionIndex( -1 )
                ref.moveOptionSelection( 1, true )
            }
        }
    )
}

function createNextRace () {
    const savedRace = useRepo( EventRace ).save( {
        eventId: event.value.id,
        race: event.value.races.length === 0 ? 1 : Math.max( ...event.value.races.map( race => race.race ) ) + 1
    } )

    useRepo( EventBoatRace ).where( 'eventRaceId', null ).get().forEach( function ( boatRace ) {
        useRepo( EventBoatRace ).save( { id: boatRace.id, eventRaceId: savedRace.id } )
    } )

    event.value?.setModified()

    raceNo.value = String( savedRace.race )

    return savedRace
}

function prepareRace () {
    if ( race.value === null ) {
        const savedRace = createNextRace()

        router.push( { name: 'EventRaceTab', params: { raceId: savedRace.race } } )

        return savedRace.id
    }

    return race.value.id
}

// Like prepareRace, but stays in the current heat route instead of jumping to the plain race URL.
function prepareHeatRace () {
    if ( race.value === null ) {
        const savedRace = createNextRace()

        router.push( { name: 'EventRaceHeat', params: { raceId: savedRace.race, round: selRound.value, heat: selHeat.value } } )

        return savedRace
    }

    return race.value
}

function heatBoatFilter ( val, update ) {
    if ( val === '' ) {
        update( () => {
            heatUnfinishedBoatsList.value = heatUnfinishedBoats.value
        } )
        return
    }

    update(
        () => {
            const needle = val.toSearchable()
            heatUnfinishedBoatsList.value = heatUnfinishedBoats.value.filter( boat => boat.searchLabel.toSearchable().includes( needle ) )
        },
        ( ref: QSelect ) => {
            if ( val !== '' && ref.options.length > 0 ) {
                ref.setOptionIndex( -1 )
                ref.moveOptionSelection( 1, true )
            }
        }
    )
}

function askHeatAttr ( info, onOk ) {
    quasar.dialog( {
            component: ResultAttr,
            componentProps: {
                title: ts( info.attrType === 'percent' ? 'getPercent' : 'getPoints' ),
                label: ts( info.attrType === 'percent' ? 'percent' : 'points' ),
                value: info.attrDefault,
                type: info.attrType
            }
        } )
        .onOk( ( payload ) => {
            if ( payload.attr === null || payload.attr === undefined || isNaN( payload.attr ) )
                return

            onOk( info.attrType === 'percent' ? payload.attr / 100.0 : payload.attr )
        } )
}

function saveHeatFinish ( boatId, otherCode, attr, quiet = false ) {
    const currentRace = prepareHeatRace()

    if ( currentRace === null || currentRace === undefined )
        return

    currentRace.addHeatFinish( selClass.value, selRound.value, selHeat.value, boatId, otherCode, attr )

    event.value?.setModified()

    commitHeatChange()

    lastEnteredHeatBoatId.value = boatId

    finishedHeatSailNo.value = null
    finishedHeatSailNoField.value?.focus()

    if ( quiet )
        return

    if ( heatAllFinished.value ) {
        finishedTaskSound.play()
        notifyHeatComplete()
    }
    else {
        positiveSound.play()
    }
}

function chooseHeatBoat ( otherCode = null, force = false ) {
    if ( finishedHeatSailNo.value === null ) {
        negativeSound.play()

        quasar.notify( { icon: 'edit', message: ts( 'boatMissing' ), timeout: 2000 } )

        return
    }

    const boat = useRepo( EventBoat ).find( finishedHeatSailNo.value )

    if ( boat === null ) {
        negativeSound.play()

        return
    }

    if ( !force && heatUnfinishedBoatsList.value.filter( option => option.sailNumber === boat.sailNumber ).length > 1 ) {
        decisionNeededSound.play()

        quasar.notify( { icon: 'edit', message: ts( 'boatAlternativeWarning' ), timeout: 5000 } )

        return
    }

    const info = parseResultFormula( otherCode )

    if ( info === null )
        return

    if ( info.needAttr && info.attrType !== null ) {
        askHeatAttr( info, ( attr ) => saveHeatFinish( boat.id, otherCode, attr ) )

        return
    }

    saveHeatFinish( boat.id, otherCode, null )
}

function finishHeatBoat ( boat ) {
    const currentRace = prepareHeatRace()

    if ( currentRace === null || currentRace === undefined )
        return

    currentRace.addHeatFinish( selClass.value, selRound.value, selHeat.value, boat.id )

    event.value?.setModified()

    commitHeatChange()

    lastEnteredHeatBoatId.value = boat.id

    if ( heatAllFinished.value ) {
        finishedTaskSound.play()
        notifyHeatComplete()
    }
    else {
        positiveSound.play()
    }
}

function addMissingHeat ( otherCode ) {
    const currentRace = prepareHeatRace()

    if ( currentRace === null || currentRace === undefined )
        return

    currentRace.addMissingHeatResults( selClass.value, selRound.value, selHeat.value, otherCode )

    event.value?.setModified()

    commitHeatChange()

    lastEnteredHeatBoatId.value = null
}

function removeHeatResultUi ( heatResult ) {
    quasar.dialog( {
            component: Confirmation,
            componentProps: {
                icon: 'warning',
                question: ts( 'removeResultQuestion', {
                    sailNo: heatResult.boat?.sailNo,
                    boatClass: heatResult.boat?.boatClass?.name,
                    result: heatResult.result
                } )
            }
        } )
        .onOk( () => {
            race.value?.removeHeatResult( heatResult )

            event.value?.setModified()

            commitHeatChange()

            lastEnteredHeatBoatId.value = null
        } )
}

function updateHeatOrder ( heatResult, val, origVal = null ) {
    const boatClass = heatResult.boat?.boatClassId
    const removedOrder = heatResult.order
    const results = race.value?.filteredHeatResults( boatClass, heatResult.round, heatResult.heat ).filter( ( hr ) => hr.order !== null ) ?? []
    const maxOrder = ( results.length > 0 ? Math.max( ...results.map( ( hr ) => hr.order ) ) : 0 ) + ( removedOrder === null ? 1 : 0 )
    const numericVal = Number( val )

    if ( !Number.isFinite( numericVal ) || !Number.isInteger( numericVal ) || numericVal < 1 || numericVal > maxOrder || numericVal === removedOrder ) {
        negativeSound.play()
        quasar.notify( { icon: 'edit', message: ts( 'invalidOrderRange', { order: val, min: 1, max: maxOrder } ), timeout: 3000 } )
        useRepo( EventHeatResult ).save( { id: heatResult.id, order: origVal } )
        return
    }

    race.value?.setHeatResultOrder( heatResult, numericVal )

    event.value?.setModified()

    commitHeatChange()

    lastEnteredHeatBoatId.value = null
}

function updateHeatOther ( heatResult, val ) {
    if ( heatResult.other === val )
        return

    const info = parseResultFormula( val )

    if ( info === null )
        return

    if ( info.needAttr && info.attrType !== null ) {
        askHeatAttr( info, ( attr ) => {
            race.value?.setHeatResultOther( heatResult, val, attr )
            event.value?.setModified()
            commitHeatChange()
        } )

        return
    }

    race.value?.setHeatResultOther( heatResult, val )

    event.value?.setModified()

    commitHeatChange()
}

function notifyHeatComplete () {
    quasar.notify( { icon: 'sports_score', message: ts( 'heatComplete' ), timeout: 3000 } )
}

// Auto-commit the elimination standings into EventResult after every heat change, so the normal
// results/print/scoring stay in sync without the user having to press "write race results".
function commitHeatChange () {
    race.value?.writeEliminationResults( selClass.value )
}

function chooseBoat ( otherCode, force = false, handicapFinishTime = null ) {
    if ( finishedSailNo.value === null ) {
        negativeSound.play()

        quasar.notify( {
            icon: 'edit',
            message: ts( 'boatMissing' ),
            timeout: 2000
        } )

        return
    }

    const boat = useRepo( EventBoat ).find( finishedSailNo.value )

    const selected = boat.sailNumber

    if ( !force && unfinishedBoatsList.value.filter( boat => boat.sailNumber === selected ).length > 1 ) {
        decisionNeededSound.play()

        quasar.notify( {
            icon: 'edit',
            message: ts( 'boatAlternativeWarning' ),
            timeout: 5000
        } )

        return
    }

    if ( boat === null ) {
        negativeSound.play()

        return
    }

    if ( otherCode === null && handicapFinishTime === null && boat.eventClassHandicapSystem !== null ) {
        quasar.dialog( {
                component: ResultHandicap,
                componentProps: {
                    title: boat.sailNo,
                    label: ts( 'finishTime' ),
                    value: ds( new Date(), DateFormat.Time )
                }
            } )
            .onOk( ( payload ) => {
                const finishTime = new Date( handicapBaseDate + 'T' + payload.finishTime )

                chooseBoat( otherCode, force, finishTime )
            } )

        return
    }

    const raceId = prepareRace()

    const formula = otherCode === null ? 'order' : otherResultFormula( otherCode )

    if ( formula === null )
        return

    const needOrder = formula.includes( 'order' )
    const needAttr = formula.includes( 'attr' )

    if ( needAttr ) {
        const matches = formula.match( /attr\[\s*(percent|points)\s*(?:\|\s*(\d+))?\s*\]/ )

        if ( matches ) {
            const attrType = matches[ 1 ]
            const attrDefault = ( matches.length > 1 && matches[ 2 ] !== undefined ) ? parseInt( matches[ 2 ] ) : 0

            quasar.dialog( {
                    component: ResultAttr,
                    componentProps: {
                        title: ts( attrType === 'percent' ? 'getPercent' : 'getPoints' ),
                        label: ts( attrType === 'percent' ? 'percent' : 'points' ),
                        value: attrDefault,
                        type: attrType
                    }
                } )
                .onOk( ( payload ) => {
                    if ( payload.attr === null || payload.attr === undefined || isNaN( payload.attr ) )
                        return

                    const results = useRepo( EventResult ).where( 'eventRaceId', raceId ).whereHas( 'boat', ( query ) => {
                        query.where( 'boatClassId', boat.boatClassId )
                    } ).whereNotNull( 'order' ).get()

                    const counter = useRepo( EventResult ).where( 'eventRaceId', raceId ).orderBy( 'counter', 'desc' ).first()

                    useRepo( EventResult ).save( {
                        eventId: event.value.id,
                        eventRaceId: raceId,
                        eventBoatId: finishedSailNo.value,
                        order: needOrder ? ( results.length === 0 ? 1 : Math.max( ...results.map( result => result.order ) ) + 1 ) : null,
                        other: otherCode,
                        attr: attrType === 'percent' ? payload.attr / 100.0 : payload.attr,
                        counter: counter === null ? 1 : counter.counter + 1,
                        ts: new Date(),
                        finishTime: null
                    } )

                    event.value?.setModified()

                    lastEnteredBoatId.value = finishedSailNo.value

                    notifyAboutLastBoat( finishedSailNo.value )

                    finishedSailNo.value = null
                    finishedSailNoField.value.focus()
                } )

            return
        }
    }

    const results = useRepo( EventResult ).where( 'eventRaceId', raceId ).whereHas( 'boat', ( query ) => {
        query.where( 'boatClassId', boat.boatClassId )
    } ).whereNotNull( 'order' ).get()

    const counter = useRepo( EventResult ).where( 'eventRaceId', raceId ).orderBy( 'counter', 'desc' ).first()

    useRepo( EventResult ).save( {
        eventId: event.value.id,
        eventRaceId: raceId,
        eventBoatId: finishedSailNo.value,
        order: needOrder ? ( results.length === 0 ? 1 : Math.max( ...results.map( result => result.order ) ) + 1 ) : null,
        other: otherCode,
        counter: counter === null ? 1 : counter.counter + 1,
        ts: new Date(),
        finishTime: handicapFinishTime
    } )

    event.value?.setModified()

    showLastBoat( finishedSailNo.value )

    if ( notifyAboutLastBoat( finishedSailNo.value ) )
        finishedTaskSound.play()
    else
        positiveSound.play()

    finishedSailNo.value = null
    finishedSailNoField.value.focus()
}

function showLastBoat ( boatId ) {
    lastEnteredBoatId.value = boatId

    if ( resultsEnterModel.value !== ResultsEnterModel.EnterCountRounds && raceResultStyle.value === RaceResultStyle.ScrollableTable
        && raceResultsField.value !== undefined && currentResults.value !== undefined ) {

        const index = currentResults.value.findIndex( r => r.boat?.id === boatId )

        // ISSUE: https://github.com/quasarframework/quasar/discussions/11861 -> diky debounce pro observer na pocitani vysky se musi pockat lehce dele nez 100 :)
        setTimeout( function () {
            raceResultsField.value.scrollTo( index, 'center-force' )
        }, 200 )
    }
}

function addMissing ( otherCode ) {
    if ( race.value === null )
        return

    const raceId = race.value.id

    const finishedBoatds = race.value.results.map( result => result.eventBoatId )

    const unfinishedBoats = event.value?.filteredBoats( ( selClass.value === '-all' ) ? null : selClass.value )
        .filter( boat => !finishedBoatds.includes( boat.id ) )

    const counter = useRepo( EventResult ).where( 'eventRaceId', raceId ).orderBy( 'counter', 'desc' ).first()

    let iter = counter === null ? 1 : counter.counter + 1

    unfinishedBoats.forEach( boat => {
        useRepo( EventResult ).save( {
            eventId: event.value.id,
            eventRaceId: raceId,
            eventBoatId: boat.id,
            other: otherCode,
            counter: iter++,
            ts: new Date(),
            finishTime: null
        } )
    } )

    event.value?.setModified()

    lastEnteredBoatId.value = null
}

function removeResult ( result ) {
    quasar.dialog( {
            component: Confirmation,
            componentProps: {
                icon: 'warning',
                question: ts( 'removeResultQuestion', {
                    sailNo: result.boat?.sailNo,
                    boatClass: result.boat?.boatClass.name,
                    result: result.result
                } )
            }
        } )
        .onOk( () => {
            const removedOrder = result.order
            const boatClass = result.boat?.boatClass.id
            const raceId = result.eventRaceId

            useRepo( EventResult ).destroy( result.id )

            lastEnteredBoatId.value = null

            if ( removedOrder === null || removedOrder === 0 )
                return

            const affectedBoats = useRepo( EventResult ).where( 'eventRaceId', raceId ).whereHas( 'boat', ( query ) => {
                query.where( 'boatClassId', boatClass )
            } ).whereNotNull( 'order' ).where( result => result.order > removedOrder ).get()

            useRepo( EventResult ).save( affectedBoats.map( boat => ( { id: boat.id, order: boat.order - 1 } ) ) )

            event.value?.setModified()
        } )
}

function updateResultFinishTime ( result, val ) {
    if ( result.order === null ) {
        const raceId = result.eventRaceId

        const results = useRepo( EventResult ).where( 'eventRaceId', raceId ).whereHas( 'boat', ( query ) => {
            query.where( 'boatClassId', result.boat.boatClassId )
        } ).whereNotNull( 'order' ).get()

        const maxOrder = ( results.length > 0 ? Math.max( ...results.map( result => result.order ) ) : 0 ) + 1

        useRepo( EventResult ).save( { id: result.id, order: maxOrder, other: null } )
    }

    useRepo( EventResult ).save( { id: result.id, finishTime: new Date( handicapBaseDate + 'T' + val ) } )

    event.value?.setModified()
}

function updateResultOrder ( result, val, origVal = null ) {
    const boatClass = result.boat.boatClass.id
    const raceId = result.eventRaceId
    const removedOrder = result.order
    const numericVal = Number( val )

    const results = useRepo( EventResult ).where( 'eventRaceId', raceId ).whereHas( 'boat', ( query ) => {
        query.where( 'boatClassId', result.boat.boatClassId )
    } ).whereNotNull( 'order' ).get()

    const maxOrder = ( results.length > 0 ? Math.max( ...results.map( result => result.order ) ) : 0 ) + ( removedOrder === null ? 1 : 0 )

    if ( !Number.isFinite( numericVal ) || !Number.isInteger( numericVal ) || numericVal < 1 || numericVal > maxOrder || numericVal === removedOrder ) {
        negativeSound.play()
        quasar.notify( { icon: 'edit', message: ts( 'invalidOrderRange', { order: val, min: 1, max: maxOrder } ), timeout: 3000 } )
        useRepo( EventResult ).save( { id: result.id, order: origVal } )

        return
    }

    lastEnteredBoatId.value = null

    if ( removedOrder === null && numericVal === maxOrder ) {
        useRepo( EventResult ).save( { id: result.id, order: numericVal, other: null } )

        event.value?.setModified()

        return
    }

    const affectedBoats = useRepo( EventResult ).where( 'eventRaceId', raceId ).whereHas( 'boat', ( query ) => {
        query.where( 'boatClassId', boatClass )
    } ).whereNotNull( 'order' ).where( res =>
        ( removedOrder !== null && removedOrder < numericVal )
            ? res.order <= numericVal && res.order > removedOrder
            : res.order >= numericVal && ( removedOrder === null || res.order < removedOrder )
    ).get()

    useRepo( EventResult ).save( affectedBoats.map( boat => ( {
        id: boat.id,
        order: boat.order + ( ( removedOrder !== null && removedOrder < numericVal ) ? -1 : 1 )
    } ) ) )

    useRepo( EventResult ).save( { id: result.id, order: numericVal, other: null } )

    event.value?.setModified()
}

function updateResultOther ( result, val ) {
    if ( result.other === val )
        return

    const formula = otherResultFormula( val )

    if ( formula === null )
        return

    if ( formula.includes( 'attr' ) ) {
        const matches = formula.match( /attr\[\s*(percent|points)\s*(?:\|\s*(\d+))?\s*\]/ )

        if ( matches ) {
            const attrType = matches[ 1 ]
            const attrDefault = ( matches.length > 1 && matches[ 2 ] !== undefined ) ? parseInt( matches[ 2 ] ) : 0

            quasar.dialog( {
                    component: ResultAttr,
                    componentProps: {
                        title: ts( attrType === 'percent' ? 'getPercent' : 'getPoints' ),
                        label: ts( attrType === 'percent' ? 'percent' : 'points' ),
                        value: attrDefault,
                        type: attrType
                    }
                } )
                .onOk( ( payload ) => {
                    if ( payload.attr === null || payload.attr === undefined || isNaN( payload.attr ) )
                        return

                    updateResultOtherSecondStage( result, val, attrType === 'percent' ? payload.attr / 100.0 : payload.attr )
                } )

            return
        }
    }

    updateResultOtherSecondStage( result, val )
}

function updateResultOtherSecondStage ( result, val, attr = null ) {
    const boatClass = result.boat.boatClass.id
    const raceId = result.eventRaceId
    const removedOrder = result.order

    const info = parseResultFormula( val )

    if ( info === null )
        return

    const needOrder = info.needOrder

    if ( needOrder ) {
        if ( result.order === null ) {
            const results = useRepo( EventResult ).where( 'eventRaceId', raceId ).whereHas( 'boat', ( query ) => {
                query.where( 'boatClassId', result.boat.boatClassId )
            } ).whereNotNull( 'order' ).get()

            useRepo( EventResult ).save( {
                id: result.id,
                order: results.length === 0 ? 1 : Math.max( ...results.map( result => result.order ) ) + 1
            } )
        }

        useRepo( EventResult ).save( { id: result.id, other: val, attr: attr } )

        event.value?.setModified()

        lastEnteredBoatId.value = null

        return
    }

    if ( info.orderBehavior === 'preserve' ) {
        useRepo( EventResult ).save( { id: result.id, other: val, attr: attr, finishTime: null } )

        event.value?.setModified()

        lastEnteredBoatId.value = null

        return
    }

    if ( removedOrder !== null ) {
        const affectedBoats = useRepo( EventResult ).where( 'eventRaceId', raceId ).whereHas( 'boat', ( query ) => {
            query.where( 'boatClassId', boatClass )
        } ).whereNotNull( 'order' ).where( res => res.order > removedOrder ).get()

        useRepo( EventResult ).save( affectedBoats.map( boat => ( { id: boat.id, order: boat.order - 1 } ) ) )
    }

    useRepo( EventResult ).save( { id: result.id, order: null, other: val, attr: attr, finishTime: null } )

    event.value?.setModified()

    lastEnteredBoatId.value = null
}

function removeResultsForClass ( boatClass ) {
    quasar.dialog( {
            component: Confirmation,
            componentProps: {
                icon: 'warning',
                question: ts( 'removeResultForClassQuestion', {
                    boatClass: useRepo( BoatClass ).find( boatClass )?.name
                } )
            }
        } )
        .onOk( () => {
            const allBoats = useRepo( EventResult ).where( 'eventRaceId', race.value.id ).whereHas( 'boat', ( query ) => {
                query.where( 'boatClassId', boatClass )
            } ).get().map( result => result.id )

            useRepo( EventResult ).destroy( allBoats )

            event.value?.setModified()

            lastEnteredBoatId.value = null
        } )
}

function reorderResults ( from, to ) {
    const offset = ( pagination.value.page - 1 ) * pagination.value.rowsPerPage

    const firstResult = currentResults.value[ offset + from - 1 ]
    const secondResult = currentResults.value[ offset + to - 1 ]

    if ( firstResult.order === null || secondResult.order === null )
        return

    if ( firstResult.boat.boatClassId !== secondResult.boat.boatClassId )
        return

    const firstOrder = firstResult.order
    const secondOrder = secondResult.order

    const direction = firstOrder < secondOrder ? 1 : -1

    lastEnteredBoatId.value = null

    const allAffected = useRepo( EventResult ).where( 'eventRaceId', firstResult.eventRaceId )
        .where( 'order', ( value ) => {
            return direction === 1 ? ( value >= firstOrder && value <= secondOrder ) : ( value <= firstOrder && value >= secondOrder )
        } )
        .orderBy( 'order', direction === 1 ? 'asc' : 'desc' ).get()

    if ( allAffected.length <= 1 )
        return

    const firstOne = allAffected.shift()

    let prevOrder = firstOne.order
    let results = []

    allAffected.forEach( function ( item ) {
        results.push( { id: item.id, order: prevOrder } )

        prevOrder = item.order
    } )

    results.push( { id: firstOne.id, order: prevOrder } )

    useRepo( EventResult ).save( results )

    event.value?.setModified()
}

function removeRace () {
    useRepo( EventRaceSkippedClass ).where( 'eventRaceId', race.value.id ).get().forEach( skipRace => useRepo( EventRaceSkippedClass ).destroy( skipRace.id ) )

    useRepo( EventRaceDetailedClass ).where( 'eventRaceId', race.value.id ).get().forEach( detailedRace => useRepo( EventRaceDetailedClass ).destroy( detailedRace.id ) )

    useRepo( EventBoatRace ).where( 'eventRaceId', race.value.id ).get().forEach( boatRace => useRepo( EventBoatRace ).destroy( boatRace.id ) )

    useRepo( EventRace ).save( event.value.races.filter( r => r.race > race.value.race ).map( r => ( {
        id: r.id,
        race: r.race - 1
    } ) ) )

    useRepo( EventRace ).destroy( race.value.id )

    event.value?.setModified()

    lastEnteredBoatId.value = null

    router.push( { name: 'EventRaceTab' } )
}

function skipRace ( boatClassId ) {
    useRepo( EventRaceSkippedClass ).save( { eventRaceId: race.value.id, boatClassId: boatClassId } )

    event.value?.setModified()
}

function unskipRace ( boatClassId ) {
    const skippedClass = useRepo( EventRaceSkippedClass ).where( 'eventRaceId', race.value.id ).where( 'boatClassId', boatClassId ).first()

    if ( skippedClass !== null ) {
        useRepo( EventRaceSkippedClass ).destroy( skippedClass.id )

        event.value?.setModified()
    }
}

function setResultsMode ( mode ) {
    resultsEnterModel.value = mode

    useRepo( EventsRepo ).save( { id: event.value.id, currentResultsEnterMode: mode } )

    lastEnteredBoatId.value = null
}

function finishBoat ( selBoat, roundsFinished = null ) {
    const raceId = prepareRace()
    const boat = useRepo( EventBoat ).find( selBoat.id )

    if ( boat === null )
        return

    const results = useRepo( EventResult ).where( 'eventRaceId', raceId ).whereHas( 'boat', ( query ) => {
        query.where( 'boatClassId', boat.boatClassId )
    } ).whereNotNull( 'order' ).get()

    const counter = useRepo( EventResult ).where( 'eventRaceId', raceId ).orderBy( 'counter', 'desc' ).first()

    const currTs = new Date()

    useRepo( EventResult ).save( {
        eventId: event.value.id,
        eventRaceId: raceId,
        eventBoatId: selBoat.id,
        rounds: roundsFinished,
        order: ( results.length === 0 ? 1 : Math.max( ...results.map( result => result.order ) ) + 1 ),
        other: null,
        counter: counter === null ? 1 : counter.counter + 1,
        ts: currTs,
        finishTime: boat.eventClassHandicapSystem !== null ? new Date( handicapBaseDate + 'T' + ds( currTs, DateFormat.Time ) + 'Z' ) : null
    } )

    event.value?.setModified()

    showLastBoat( selBoat.id )

    if ( notifyAboutLastBoat( selBoat.id ) )
        finishedTaskSound.play()
}

function notifyAboutLastBoat ( selBoat ) {
    const boat = useRepo( EventBoat ).find( selBoat )

    if ( event.value.unfinishedBoats( race.value, boat.boatClassId ).length !== 0 )
        return false

    const boatClass = useRepo( BoatClass ).find( boat.boatClassId )

    quasar.notify( {
        icon: 'sports_score',
        message: ts( 'lastBoatFor', { race: race.value.race, boatClass: boatClass.name } ),
        timeout: 3000
    } )

    return true
}

async function printFinishSheet () {
    const reportLocale = event.value.forceEnglishReports ? 'en' : localization.global.locale.value

    let counter = 0

    const document = await buildPrintMeta( {
        event: event.value,
        title: ts( 'finishSheet', { race: raceNo.value }, { locale: reportLocale } ),
        locale: reportLocale
    } )

    const content = {
        ...document,
        content: [
            buildStandardHeader( event.value, { locale: reportLocale } ),
            {
                marginTop: 4,
                table: {
                    headerRows: 1,
                    widths: [ 'auto', 'auto', 'auto', ...( ( useBoatNames.value && isBoatNamesUsed.value ) ? [ 'auto' ] : [] ), 'auto', '*' ],
                    body: [
                        [
                            { text: ts( 'orderShortcut', {}, { locale: reportLocale } ), style: 'em' },
                            { text: ts( 'boatClass', {}, { locale: reportLocale } ), style: 'em' },
                            { text: ts( 'sailNo', {}, { locale: reportLocale } ), style: 'em' },
                            ...( ( useBoatNames.value && isBoatNamesUsed.value ) ? [ {
                                text: ts( 'boatName', {}, { locale: reportLocale } ),
                                style: 'em'
                            }
                            ] : [] ),
                            { text: ts( 'result', {}, { locale: reportLocale } ), style: 'em' },
                            { text: ts( 'captain', {}, { locale: reportLocale } ), style: 'em' }
                        ],
                        ...( currentResults.value.sort( ( a, b ) => ( a.counter - b.counter ) ).map( r => [
                            { text: ( ++counter ) + '.', alignment: 'right' },
                            r.boat.eventClassName,
                            r.boat.sailNo,
                            ...( ( useBoatNames.value && isBoatNamesUsed.value ) ? [ r.boat.name ?? '' ] : [] ),
                            { text: r.result, alignment: !isNaN( parseInt( r.result ) ) ? 'right' : 'left' },
                            r.boat.crew.filter( c => c.captain ).length > 0 ? r.boat.crew.filter( c => c.captain )[ 0 ].reverseFullName : ''
                        ] ) )
                    ]
                },
                layout: {
                    vLineWidth: () => ( 0 ),
                    hLineWidth: ( i, node ) => ( ( i === node.table.headerRows || i === node.table.body.length ) ? 1 : 0 ),
                    vLineColor: 'black'
                },
                style: 'results'
            }
        ]
    }

    pdfMake.createPdf( content ).download( 'sheet-' + event.value.ctlId + '-r' + raceNo.value + '-' + '.pdf' )
}

// Print the round's heats division across all groups in the standard start-list format,
// with an added "group" column and the elimination + round marked in the header.
async function printHeatsDivision () {
    const eventClass = selectedEventClass.value

    if ( eventClass === null || eventClass === undefined )
        return

    const reportLocale = event.value.forceEnglishReports ? 'en' : localization.global.locale.value

    const useDesc = event.value.descInResultsTitle !== null && event.value.descInResultsTitle !== undefined && event.value.descInResultsTitle.length !== 0
    const useCrewDesc = event.value.crewDescInResultsTitle !== null && event.value.crewDescInResultsTitle !== undefined && event.value.crewDescInResultsTitle.length !== 0
    const boatNamesUsed = ( eventClass.boatClass?.useBoatNames ?? false ) && isBoatNamesUsed.value
    const wsIdRequired = event.value.wsEventId !== null && event.value.wsEventId !== undefined && event.value.wsEventId.length > 0

    // Wide layouts (several descriptive columns) print better in landscape.
    let factor = 0
    if ( useCrewDesc ) ++factor
    if ( useDesc ) ++factor
    if ( boatNamesUsed ) ++factor
    if ( wsIdRequired ) ++factor

    // Build one table row in the exact column order; unset cells render empty.
    const row = ( cells ) => [
        cells.order ?? '',
        cells.group ?? '',
        cells.sailNo ?? '',
        cells.lastName ?? '',
        cells.firstName ?? '',
        cells.regId ?? '',
        ...( wsIdRequired ? [ cells.wsId ?? '' ] : [] ),
        cells.category ?? '',
        cells.born ?? '',
        cells.sex ?? '',
        ...( boatNamesUsed ? [ cells.boatName ?? '' ] : [] ),
        ...( useCrewDesc ? [ cells.crewNote ?? '' ] : [] ),
        ...( useDesc ? [ cells.detail ?? '' ] : [] ),
        cells.club ?? ''
    ]

    const body = [
        row( {
            order: { text: ts( 'orderShortcut', {}, { locale: reportLocale } ).toLowerCase(), style: 'em' },
            group: { text: ts( 'group', {}, { locale: reportLocale } ).toLowerCase(), style: 'em' },
            sailNo: { text: ts( 'sailNo', {}, { locale: reportLocale } ).toLowerCase(), style: 'em' },
            lastName: { text: ts( 'lastName', {}, { locale: reportLocale } ).toLowerCase(), style: 'em' },
            firstName: { text: ts( 'name', {}, { locale: reportLocale } ).toLowerCase(), style: 'em' },
            regId: { text: ts( 'regId', {}, { locale: reportLocale } ).toLowerCase(), style: 'em' },
            wsId: { text: ts( 'wsId', {}, { locale: reportLocale } ).toLowerCase(), style: 'em' },
            category: { text: ts( 'categoryShortcut', {}, { locale: reportLocale } ).toLowerCase(), style: 'em' },
            born: { text: ts( 'bornShortcut', {}, { locale: reportLocale } ).toLowerCase(), style: 'em' },
            sex: { text: ts( 'sexShort', {}, { locale: reportLocale } ).toLowerCase(), style: 'em' },
            boatName: { text: ts( 'boatName', {}, { locale: reportLocale } ).toLowerCase(), style: 'em' },
            crewNote: { text: event.value.crewDescInResultsTitle, style: 'em' },
            detail: { text: event.value.descInResultsTitle, style: 'em' },
            club: { text: ts( 'club', {}, { locale: reportLocale } ).toLowerCaseFirst(), style: 'em' }
        } )
    ]

    // A light rule separates the groups: it is drawn above the first row of every group but the first.
    const groupSeparatorRows: number[] = []
    let previousGroup = null

    heatsDivisionRows.value.forEach( ( { boat, group, order } ) => {
        if ( previousGroup !== null && group !== previousGroup )
            groupSeparatorRows.push( body.length )

        previousGroup = group

        const boatCells = {
            order: { text: order + '.', alignment: 'right' },
            group: { text: group ?? '', style: 'smaller' },
            sailNo: boat.sailNo,
            category: { text: boat.orderedCategories.map( category => category.visibleShortcut ).join( ', ' ), style: 'smaller' },
            boatName: { text: nvl( boat.name, '' ).shorten( 22 ), style: 'smaller' },
            detail: { text: boat.detail ?? '', style: 'smaller' }
        }

        const crewList = boat.orderedCrewList

        if ( crewList === undefined || crewList === null || crewList.length === 0 ) {
            body.push( row( boatCells ) )

            return
        }

        crewList.forEach( ( crew, index ) => {
            body.push( row( {
                ...( index === 0 ? boatCells : {} ),
                lastName: crew.lastName?.shorten( 30 ) ?? '',
                firstName: crew.firstName?.shorten( 30 ) ?? '',
                regId: crew.regId,
                wsId: crew.wsId ?? '',
                born: crew.birthYear ?? '',
                sex: crew.sex === 'male' ? ts( 'maleShortcut', {}, { locale: reportLocale } ) : ts( 'femaleShortcut', {}, { locale: reportLocale } ),
                crewNote: { text: crew.note, style: 'smaller' },
                club: { text: crew.visibleClub?.shorten( 22 ) ?? '', style: boatNamesUsed ? 'smaller' : '' }
            } ) )
        } )
    } )

    const document = await buildPrintMeta( {
        event: event.value,
        title: ts( 'heatsDivision', {}, { locale: reportLocale } ),
        pageOrientation: factor >= 2 ? 'landscape' : 'portrait',
        locale: reportLocale
    } )

    const content = {
        ...document,
        content: [
            buildStandardHeader( event.value, { locale: reportLocale } ),
            {
                marginTop: 8,
                marginBottom: 8,
                table: {
                    headerRows: 0,
                    widths: [ '*', '*' ],
                    body: [
                        [
                            {
                                marginTop: 4,
                                marginBottom: 4,
                                marginLeft: 4,
                                text: [
                                    { text: ts( 'boatClassShortcut', {}, { locale: reportLocale } ) + ':  ', style: 'em' },
                                    { text: eventClass.eventClassName, style: 'em' }
                                ]
                            },
                            {
                                marginTop: 4,
                                marginBottom: 4,
                                marginRight: 4,
                                alignment: 'right',
                                text: [
                                    { text: ts( 'eliminationNo', { no: raceNo.value }, { locale: reportLocale } ) + ' — ', style: 'em' },
                                    { text: ts( 'roundNo', { no: selRound.value }, { locale: reportLocale } ), style: 'em' }
                                ]
                            }
                        ]
                    ]
                },
                layout: {
                    vLineWidth: ( i, node ) => ( ( i === 0 || i === node.table.widths.length ) ? 1 : 0 ),
                    hLineWidth: ( i, node ) => ( ( i === 0 || i === node.table.body.length ) ? 1 : 0 ),
                    hLineColor: 'black',
                    vLineColor: 'black'
                }
            },
            {
                table: {
                    headerRows: 1,
                    widths: [
                        'auto', 'auto', 'auto', 'auto', '*', 'auto',
                        ...( wsIdRequired ? [ 'auto' ] : [] ),
                        'auto', 'auto', 'auto',
                        ...( boatNamesUsed ? [ '*' ] : [] ),
                        ...( useCrewDesc ? [ '*' ] : [] ),
                        ...( useDesc ? [ '*' ] : [] ),
                        '*'
                    ],
                    body: body
                },
                layout: {
                    vLineWidth: () => ( 0 ),
                    hLineWidth: ( i, node ) => ( ( i === node.table.headerRows || i === node.table.body.length )
                        ? 1
                        : ( groupSeparatorRows.includes( i ) ? .5 : 0 ) ),
                    vLineColor: 'black',
                    hLineColor: ( i, node ) => ( ( i === node.table.headerRows || i === node.table.body.length ) ? 'black' : '#ccc' )
                },
                style: 'crewlist'
            }
        ]
    }

    pdfMake.createPdf( content ).download( 'ctl-' + event.value.ctlId + '-heats-division-'
        + eventClass.boatClass.shortcut.toLowerCase()
        + ( raceNo.value !== undefined ? '-r' + raceNo.value : '' ) + '-round' + selRound.value + '.pdf' )
}

function setRaceStartTime ( boatClassId, val, origVal, specialBehavior = null ) {
    if ( val === origVal && specialBehavior === null ) // This is a bit simplified, but it was enough for popup-edit
        return

    const startTime = new Date( handicapBaseDate + 'T' + val )

    const raceId = prepareRace()

    const detailedClass = useRepo( EventRaceDetailedClass ).where( 'eventRaceId', raceId ).where( 'boatClassId', boatClassId ).first()

    if ( detailedClass !== null ) {
        useRepo( EventRaceDetailedClass ).save( { id: detailedClass.id, startTime: startTime, specialBehavior: specialBehavior } )
    } else {
        useRepo( EventRaceDetailedClass ).save( {
            eventRaceId: raceId,
            boatClassId: boatClassId,
            startTime: startTime,
            specialBehavior: specialBehavior
        } )
    }

    event.value?.setModified()
}

function editRaceStartTime ( boatClassId ) {
    const detailedClass = useRepo( EventRaceDetailedClass ).where( 'eventRaceId', race?.value?.id ).where( 'boatClassId', boatClassId ).first()
    const initialStartTime = race.value?.startTime( boatClassId, true ) || '00:00:00'

    quasar.dialog( {
        component: StartTime,
        componentProps: {
            initialStartTime: initialStartTime,
            initialSpecialBehavior: detailedClass?.specialBehavior || null,
            raceNo: race.value?.race || ( ( event.value?.races.length || 0 ) + 1 )
        }
    } ).onOk( ( data ) => {
        setRaceStartTime( boatClassId, data.startTime, null, data.specialBehavior )
    } )
}

function showUnfinished ( unfinished ) {
    quasar.dialog( {
        component: BoatList,
        componentProps: {
            boatList: unfinished
        }
    } )
}

function countRound ( selBoat ) {
    const raceId = prepareRace()
    const counter = useRepo( EventRound ).where( 'eventRaceId', raceId ).orderBy( 'counter', 'desc' ).first()
    const boat = useRepo( EventBoat ).find( selBoat.id )

    if ( boat === null )
        return

    const lastRound = useRepo( EventRound ).save( {
        eventId: event.value.id,
        eventRaceId: raceId,
        eventBoatId: selBoat.id,
        counter: counter === null ? 1 : counter.counter + 1,
        ts: new Date()
    } )

    if ( finishIsOpened.value ) {
        const roundsFinished = useRepo( EventRound ).where( 'eventRaceId', raceId ).where( 'eventBoatId', selBoat.id ).get().length

        finishBoat( selBoat, roundsFinished )
    }

    event.value?.setModified()

    lastEnteredRoundId.value = lastRound.id

    if ( raceRoundsField.value !== undefined && currentRounds.value !== undefined ) {
        const index = currentRounds.value.findIndex( r => r.id === lastRound.id )

        setTimeout( function () {
            raceRoundsField.value.scrollTo( index, 'center-force' )
        }, 200 )
    }
}

function removeRound ( round: EventRound ) {
    const result = useRepo( EventResult ).where( 'eventBoatId', round.eventBoatId ).where( 'eventRaceId', round.eventRaceId ).first()

    if ( result !== null )
        return

    quasar.dialog( {
            component: Confirmation,
            componentProps: {
                icon: 'warning',
                question: ts( 'removeRoundQuestion', {
                    sailNo: round.boat?.sailNo,
                    boatClass: round.boat?.boatClass.name,
                    ts: ds( round.ts, DateFormat.Time )
                } )
            }
        } )
        .onOk( () => {
            useRepo( EventRound ).destroy( round.id )

            event.value?.setModified()

            lastEnteredRoundId.value = null
        } )
}

// TODO pokud uz lod ma vysledek, asi bych mel uplne schovat ikonku mazani prujezdu :(
// TODO smazani dojezdu cele lodni tridy by melo asi vymazat i prujezdy lodi

/*
If a boat ends with a corrected time greater than a boat which completed less laps but has the same PN,
a modifying calculation should be applied as follows:
Modified time = Corrected time x multiplier
Multiplier = (slowest x (fastest laps – 1)) / (about to finish time x fastest laps)
Where:
Fastest Laps is Actual Laps completed by the fastest boat in the group. Slowest is the Elapsed Time of
the slowest boat in the group[*, to complete Fastest Laps].
NB. This is only applied to a group of boats with the same PN where one or more have been effected by sailing differing number of laps and
the corrected times do not reflect a fair outcome.”
 */

</script>

<style scoped lang="sass">
.minicrewlist
  font-size: 80% !important

.captain
  font-weight: bold

.class-separator td
  border-top: solid 1px

.unfinished
  color: $negative
  font-weight: bold

// Target the cells (not the table): Quasar's .q-table tbody td rule overrides a font size set on the
// table element, so the class-name cells would otherwise render at the full 13px instead of shrinking.
.unfinished-table td, .unfinished-table th
  font-size: 90%

.results-table
  font-size: 90%

.boat-btn .boat-class, .boat-btn .sail-no, .boat-btn .boat-captain, .boat-btn .boat-name
  display: block
  width: 100%

.boat-btn .sail-no
  margin-top: 2px

.boat-btn .boat-captain, .boat-btn .boat-name
  font-size: 90%
  line-height: 1em
  margin-bottom: 6px

.boat-btn .boat-class
  font-size: 80%
  line-height: 1em
  margin-bottom: 4px

.boat-btn.finished
  opacity: .3 !important

.thead-sticky tr > *
  position: sticky
  opacity: 1
  z-index: 1
  background: white

.thead-sticky tr:last-child > *
  top: 0

.scrollable-results
  overflow-x: hidden
  max-height: 60vh
  min-height: 500px

.last-entered-result
  background-color: lightcyan

.long-desc
  font-size: 80%

.row > .col-3a
  height: auto
  width: 22%
</style>
